import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { SearchOff as SearchOffIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { getHomePath } from '../config/navigation';

const NotFound = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const homePath = isAuthenticated ? getHomePath(user) : '/';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 2,
        px: 2,
        bgcolor: '#f6f7f8',
      }}
    >
      <SearchOffIcon sx={{ fontSize: 64, color: 'text.secondary' }} />
      <Typography variant="h4" component="h1">
        Página no encontrada
      </Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 420 }}>
        La dirección que ingresaste no existe o fue movida. Revisá el enlace o volvé al inicio.
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Volver atrás
        </Button>
        <Button variant="contained" component={RouterLink} to={homePath}>
          Ir al inicio
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
